import './Section.css'
import { ReactNode } from 'react'

interface SectionProps {
  id?: string
  title?: string
  subtitle?: string
  children: ReactNode
  centered?: boolean
  background?: 'default' | 'light' | 'gradient'
}

function Section({ id, title, subtitle, children, centered = false, background = 'default' }: SectionProps) {
  return (
    <section id={id} className={`section section-${background} ${centered ? 'section-centered' : ''}`}>
      {(title || subtitle) && (
        <div className='section-header'>
          {title && <h2 className='section-title'>{title}</h2>}
          {subtitle && <div className='section-subtitle'>{subtitle}</div>}
        </div>
      )}
      <div className='section-content'>{children}</div>
    </section>
  )
}

export default Section
